import styles from "./Order.module.css"
import { PaymentSuccessModal ,OrderProductListDetailsCard ,PaymentDetailsCard,PaymentFailureModal
     ,PaymentInstrumentDetailsCard  } from "../../components"
import CrossSign from "../../asset/icons/whiteCross.png"
import CongratsImage from "../../asset/icons/congratsImage.png"
import forward from "../../asset/icons/whiteForwardCircle.png"
import whatsappIcon from "../../asset/icons/whatsapp.png"
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import cx from 'classnames';

import Api from "../../utils/Api/Api";
import { facebookCAPI } from "../../utils/FacebookCAPI";

import { useNavigate, useSearchParams } from "react-router-dom";
import React , {useState, useEffect} from "react"
import { Helmet } from "react-helmet";
import { trackPurchase } from "../../utils/analytics";
import UTMTracker from "../../utils/UTMTracker";
import SnapchatPixel from '../../utils/SnapchatPixel';
import axios from 'axios';


export const Order = (props)=>{
    const [showModal,setShowModal] = useState(false);
    const [searchParams] = useSearchParams();
    const order_id = searchParams.get("order_id")
    const [loading,setLoading] = useState(true);
    const [hasError,setError] = useState(false);
    const [orderDetails,setOrderDetails] = useState({});

    const navigate = useNavigate()
    const toggleModal = ()=>{
        localStorage.setItem('order_id', order_id)
        setShowModal((pre_state)=>(!pre_state))
    }

    useEffect(()=>{
        // Capture UTM parameters when the order page loads
        UTMTracker.captureUTMParams();
        
        // Inject a direct script to fetch IP and store it, avoiding any React/CORS issues
        if (!localStorage.getItem('user_ip_address')) {
            // Only inject if we don't already have the IP
            const ipifyScript = document.createElement('script');
            ipifyScript.innerHTML = `
                // Direct script execution in the browser
                var ipifyRequest = new XMLHttpRequest();
                ipifyRequest.open('GET', 'https://api.ipify.org/?format=json', true);
                ipifyRequest.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        // Success
                        var resp = JSON.parse(this.response);
                        console.log('IP address fetched directly:', resp.ip);
                        localStorage.setItem('user_ip_address', resp.ip);
                    }
                };
                ipifyRequest.onerror = function() {
                    console.error('Error fetching IP address');
                };
                ipifyRequest.send();
            `;
            document.body.appendChild(ipifyScript);
            
            // Remove the script after execution to clean up
            setTimeout(() => {
                if (ipifyScript.parentNode) {
                    ipifyScript.parentNode.removeChild(ipifyScript);
                }
            }, 1000);
        }
        
        const fetchCartData = async ()=>{
            try {
                // Use a slight delay to ensure IP fetch completes
                if (!localStorage.getItem('user_ip_address')) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                }
                
                let params = {
                    order_id
                }
                let { data: confirmationData } = await Api.GetOrderConfirmation(params);

                let paymentId = {
                    payment_order_id: confirmationData.payment_id
                }
                let { data: orderDetail } = await Api.GetOrderDetailsFromPaymentId(paymentId);
                if(orderDetail && orderDetail.length){
                    setOrderDetails(orderDetail[0]);
                    if(confirmationData.status === 'CHARGED' || 
                       confirmationData.payment_gateway_response?.resp_code === 'SUCCESS') {
                        
                        // Get IP from localStorage for CAPI
                        const userIP = localStorage.getItem('user_ip_address') || '';
                        console.log('Using stored IP for CAPI:', userIP);
                        
                        // Track purchase with Facebook CAPI
                        const phoneNo = localStorage.getItem('phoneNo');
                        const orderData = orderDetail[0];

                        await facebookCAPI.trackPurchase(orderData, {
                            phone: orderData?.user?.phone_number,
                            email: orderData?.user?.email || '',
                            clientIp: userIP // Use the IP address from localStorage
                        });

                        // Track with Facebook Pixel
                        window.fbq('track', 'Purchase', {
                            value: orderData.payment?.amount || 0,
                            currency: orderData.details?.currency_type || 'INR',
                            content_type: 'product',
                            content_ids: orderData.new_ordered_items?.map(item => item.subscription_plan?.subscription_plan_id) || [],
                            num_items: orderData.new_ordered_items?.length || 0,
                            payment_method: orderData.payment?.payment_method || "",
                            order_id: order_id || "",
                            discount_amount: orderData.amount_saved_dict?.amount_saved || 0,
                            fleek_coins_used: orderData.details?.coin_value_used || 0,
                            shipping_cost: 0,
                            tax: 0
                        });

                        // Track with Snapchat Pixel
                        await SnapchatPixel.trackPurchase(orderData);

                        if(localStorage.getItem('order_id') === order_id) {
                            setShowModal(2);
                        } else {
                            setShowModal(1);
                        }
                    } else {
                        navigate('/checkout?status=failed');
                        return;
                    }
                } else {
                    navigate('/checkout?status=failed');
                    return;
                }
            }
            catch(err) {
                console.error('Error tracking purchase:', err);
                setError(true);
            }
            setLoading(false)
        }
        fetchCartData();
    },[])
    
    if(hasError) {
        return <ErrorFallback />
    }
    if(loading) {
        return <Loading />
    }

    const {new_ordered_items, payment, amount_saved_dict, total_amount, details, bundle:bundleDetails} = orderDetails;
    let bundle = bundleDetails ? true : false;
    const OrderInfo = (i) => {
        UTMTracker.navigateWithParams(navigate, `/orderdetail/${new_ordered_items[i ? i : 0].id}`);
    }

    const paymentDetails = {mrp_price: bundle? bundleDetails.mrp_price: new_ordered_items[0]?.subscription_plan?.mrp_price,
         useFleekCoin: details?.coin_value_used,
         actual_discounted_cost: payment.amount,
         coin_value_reserved: details?.coin_value_used,
         cost:bundle ? bundleDetails.mrp_price - amount_saved_dict.amount_saved + details?.coin_value_used : new_ordered_items[0]?.cost - (total_amount - payment.amount),
        }

        if(showModal === 0 ) {
            return <PaymentFailureModal toggleModal={toggleModal}/>
        }
        
    const openWhatsApp = () => {
        window.open(`https://wa.me/919353853270`, '_blank');
    }

    return(
        <div>
            {/* React Helmet Script */}
      <Helmet>
        <script>
          {`
            fbq('track', 'Purchase', {
              value: ${payment?.amount || 0},
              currency: '${details?.currency_type || 'INR'}',
              content_type: 'product',
              content_ids: ${JSON.stringify(new_ordered_items?.map(item => item.subscription_plan?.subscription_plan_id) || [])},
              num_items: ${new_ordered_items?.length || 0},
              payment_method: '${payment?.payment_method || ""}',
              order_id: '${order_id || ""}',
              discount_amount: ${amount_saved_dict?.amount_saved || 0},
              fleek_coins_used: ${details?.coin_value_used || 0},
              shipping_cost: 0,
              tax: 0
            });

            // Track order status
            fbq('track', 'OrderConfirmed', {
              order_id: '${order_id || ""}',
              value: ${payment?.amount || 0},
              currency: '${details?.currency_type || 'INR'}',
              status: 'confirmed',
              items: ${JSON.stringify(new_ordered_items?.map(item => ({
                id: item.subscription_plan?.subscription_plan_id,
                name: item.subscription_plan?.plan_name,
                price: item.cost,
                quantity: 1
              })) || [])}
            });
          `}
        </script>
      </Helmet>
            {showModal === 1 && <PaymentSuccessModal payment={payment} amount_saved_dict= {amount_saved_dict} toggleModal={toggleModal}/>}
            {
            <>
                <div className={styles.headcontent}>
                    {/* <NavBar/> */}
                </div>
                <div className={(showModal === 1 || showModal === 0) ? cx(styles.content, styles.opacity25): styles.content}>
                    <div className={styles.header}>
                        <img onClick={() => {
                            UTMTracker.navigateWithParams(navigate, '/marketplace');
                        }} className={styles.crossSign} src={CrossSign} alt="CrossSign"/>
                        <p className={styles.headText}>Order Confirmed</p>
                        <p onClick={() => UTMTracker.navigateWithParams(navigate, '/support')} className={styles.helpText}>HELP</p>
                    </div>
                    <div className={styles.congratsContainer}>
                        <img className={styles.CongratsImage} src={CongratsImage} alt="CongratsImage" />
                        <p className={styles.congratsHead}>Congratulations!</p>
                        <p className={styles.congratsSubhead}>We received your order for {new_ordered_items?.length} items</p>
                    </div>
                    <div className={styles.detailContainer}>
                        <div className={styles.cardContainer}>
                            <OrderProductListDetailsCard bundle={bundle} OrderInfo={OrderInfo} orderDetails={new_ordered_items}/>
                        </div>
                        <div className={styles.otherDetail}>
                            <PaymentDetailsCard cartData={paymentDetails} useFleekCoin={paymentDetails.useFleekCoin} />
                            <PaymentInstrumentDetailsCard payment={payment}/>
                            
                            {/* WhatsApp Support Card */}
                            <div className={styles.whatsappCard} onClick={openWhatsApp}>
                                <div className={styles.whatsappContent}>
                                    <img src={whatsappIcon} alt="WhatsApp" className={styles.whatsappIcon} />
                                    <div className={styles.whatsappText}>
                                        <p className={styles.whatsappTitle}>Need activation help?</p>
                                        <p className={styles.whatsappSubtitle}>WhatsApp us now</p>
                                        <p className={styles.whatsappNumber}>+91 93538 53270</p>
                                    </div>
                                </div>
                                <img src={forward} alt="forward" className={styles.whatsappForward}/>
                            </div>

                            <div className={styles.mobileButtonContainer}>
                                <button className={styles.nextButton}
                                    onClick={() => bundle 
                                        ? UTMTracker.navigateWithParams(navigate, '/myorder') 
                                        : OrderInfo()
                                    }
                                >
                                    SEE ORDER DETAILS
                                    <img className={styles.forward} alt="forward" src={forward}/>
                                </button>
                            </div>
                        </div>
                    </div>   
                </div>
            </>
            }
        </div>
    )
}